module.exports = __webpack_public_path__ + "img/service-tab-img8.68dba31e.png";